import { ResponseWrapper } from '@/api/types/base.types'
import type { AxiosResponse } from 'axios'

export const getContractTemplateApiErrorMessage = (
  response: unknown,
  fallback: string,
): string => {
  const source = response as
    | ResponseWrapper<unknown>
    | AxiosResponse<ResponseWrapper<unknown>>
    | { response?: { data?: ResponseWrapper<unknown> } }
    | undefined

  const data =
    source && 'response' in source && source.response?.data
      ? source.response.data
      : source && 'data' in source && source.data
        ? (source.data as ResponseWrapper<unknown>)
        : (source as ResponseWrapper<unknown> | undefined)

  if (data?.status !== 'error') return fallback

  const raw = data.error
  if (Array.isArray(raw)) {
    return raw.map(String).join(' ')
  }
  if (typeof raw === 'string' && raw.trim()) {
    return raw.trim()
  }

  const fieldErrors = (data as { errors?: Record<string, unknown> }).errors
  if (fieldErrors && typeof fieldErrors === 'object') {
    const parts = Object.values(fieldErrors).flatMap((value) =>
      Array.isArray(value) ? value.map(String) : [String(value)],
    )
    const message = parts.filter(Boolean).join(' ')
    if (message) return message
  }

  return fallback
}
